<ng-container *ngIf="selectorTpl != null; else elseTpl">
  <div (click)="contentClick()">
    <ng-container *ngTemplateOutlet="selectorTpl; context: {items: items}"></ng-container>
  </div>
</ng-container>
<ng-template #elseTpl>
  <ion-item [class.invalid]="isInvalid() && isTouched()">
    <label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label>
    <ion-button fill="clear" slot="end" (click)="contentClick()" class="ion-text-right">
      <ng-container *ngIf="(comboItemTpl == null && displayTpl == null) || value == null">{{(text | async) != null && (text | async) != '' ? (text | async) : placeholder}}</ng-container>
      <ng-container *ngIf="(displayTpl == null && comboItemTpl != null) && value != null">
        <ng-container *ngTemplateOutlet="comboItemTpl; context: {items: items}"></ng-container>
      </ng-container>
      <ng-container *ngIf="(displayTpl != null) && value != null">
        <ng-container *ngTemplateOutlet="displayTpl; context: {items: items}"></ng-container>
      </ng-container>
    </ion-button>
  </ion-item>
</ng-template>
<ion-modal class="modalCustom" #modal (ionModalDidDismiss)="modal.isOpen = false">
  <ng-template>
    <ng-container *ngIf="dataSource != null">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="modal.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
          </ion-buttons>
          <ion-title>{{modalTitle}}</ion-title>
        </ion-toolbar>
        <ion-toolbar>
          <ion-searchbar [placeholder]="searchPlaceholder" #searchBar [debounce]="300" (ionInput)="onSearch()"></ion-searchbar>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-list>
          <ng-container *ngIf="(dataSource | async) != null && (dataSource | async).length && (dataSource | async).length > 0; else emptyTpl">
            <ng-container *ngFor="let item of dataSource | async">
              <ion-item class="itemList" button *ngIf="comboItemTpl == null">
                <ion-toggle class="textList" [checked]="item != null && item[valueField] != null && ((items | async).indexOf(item[valueField]?.toString()) != -1)" (ionChange)="optionSelected(item)"><label [style.marginBottom]="0" [class.selected]="item != null && item[valueField] != null && ((items | async).indexOf(item[valueField]?.toString()) != -1)">{{item != null && item[displayField] != null ? item[displayField] : ''}}</label></ion-toggle>
                <!-- <ion-label [class.textList]="true" [class.selected]="item != null && item[valueField] != null && ((items | async).indexOf(item[valueField]?.toString()) != -1)">{{item != null && item[displayField] != null ? item[displayField] : ''}}</ion-label> -->
              </ion-item>
              <ng-container *ngIf="comboItemTpl != null">
                <div (click)="optionSelected(item)">
                  <ng-container *ngTemplateOutlet="comboItemTpl; context: {item: item, selectedItems: (items | async)}"></ng-container>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ion-list>
        <ion-infinite-scroll *ngIf="dataSource.HasMoreItems | async" (ionInfinite)="onIonInfinite($event)">
          <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
        <ion-refresher #refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
          <ion-refresher-content></ion-refresher-content>
        </ion-refresher>
      </ion-content>
      <ion-footer>
        <ion-buttons slot="start">
          <ion-button (click)="clearValue()" color="danger">Limpiar</ion-button>
        </ion-buttons>
      </ion-footer>
    </ng-container>
  </ng-template>
</ion-modal>
<ng-template #emptyTpl>
  <span class="AlertNoResults">{{emptyText}}</span>
</ng-template>